import { gsap } from 'gsap';

const MOBILE = 1270;

const initNavigation = () => {
	const toggle = document.querySelector('.global-nav__toggle');
	const menu = document.querySelector('.global-nav__menu');
	const items = document.querySelectorAll('.global-nav__item');
	const links = document.querySelectorAll('.global-nav__link');
	const lines = document.querySelectorAll('.global-nav__toggle-line');
	const logoMobile = document.querySelector('.global-nav__logo-mobile-link');

	if (!toggle || !menu) return;

	let isOpen = false;
	let tl = null;

	const buildTimeline = () => {
		tl = gsap.timeline({ paused: true });

		tl.set(menu, { visibility: 'visible' });

		tl.to(menu, {
			x: '0%',
			opacity: 1,
			duration: 0.5,
			ease: 'power3.out',
		});

		tl.to(items, {
			opacity: 1,
			filter: 'blur(0px)',
			y: 0,
			duration:0.7,
			stagger: 0.06,
			ease: 'power2.out',
		}, '-=0.2');

		tl.to(lines[0], {
			rotation: 45,
			y: 8,
			duration: 0.3,
			ease: 'power2.inOut',
		}, 0);

		tl.to(lines[1], {
			opacity: 0,
			duration: 0.2,
			ease: 'power2.inOut',
		}, 0);

		tl.to(lines[2], {
			rotation: -45,
			y: -6,
			duration: 0.3,
			ease: 'power2.inOut',
		}, 0);

		return tl;
	};

	const handleOpen = () => {
		if (window.innerWidth > MOBILE) return;

		isOpen = true;
		toggle.setAttribute('aria-expanded', 'true');
		toggle.setAttribute('aria-label', 'Close menu');
		menu.classList.add('is-open');

		gsap.set(menu, { x: '100%', opacity: 0 });
		gsap.set(items, { opacity: 0, filter: 'blur(20px)',  });

		if (tl) tl.kill();
		tl = buildTimeline();
		tl.play();
	};

	const handleClose = () => {
		isOpen = false;
		toggle.setAttribute('aria-expanded', 'false');
		toggle.setAttribute('aria-label', 'Open menu');
		
		const closeTl = gsap.timeline({
			onComplete: () => {
				menu.classList.remove('is-open');
				gsap.set(menu, { clearProps: 'all' });
				gsap.set(items, { clearProps: 'all' });
			}
		});

		closeTl.to(items, {
			opacity: 0,
			y: -10,
			duration: 0.15,
			stagger: 0.02,
			ease: 'power2.in',
		});

		closeTl.to(menu, {
			x: '-100%',
			opacity: 0,
			duration: 0.20,
			ease: 'power3.in',
		}, '-=0.1');

		closeTl.to(lines[0], {
			rotation: 0,
			y: 0,
			duration: 0.3,
			ease: 'power2.inOut',
		}, 0);

		closeTl.to(lines[1], {
			opacity: 1,
			duration: 0.2,
			ease: 'power2.inOut',
		}, 0.1);

		closeTl.to(lines[2], {
			rotation: 0,
			y: 0,
			duration: 0.3,
			ease: 'power2.inOut',
		}, 0);
	};

	const handleToggle = () => {
		if (isOpen) {
			handleClose();
		} else {
			handleOpen();
		}
	};

	const handleResize = () => {
		if (window.innerWidth > MOBILE && isOpen) {
			isOpen = false;
			toggle.setAttribute('aria-expanded', 'false');
			toggle.setAttribute('aria-label', 'Open menu');
			menu.classList.remove('is-open');
			document.body.style.overflow = '';
			gsap.set(menu, { clearProps: 'all' });
			gsap.set(items, { clearProps: 'all' });
			gsap.set(lines, { clearProps: 'all' });
			if (tl) tl.kill();
		}
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Escape' && isOpen) {
			handleClose();
			toggle.focus();
		}
	};

	links.forEach((link) => {
		link.addEventListener('click', handleToggle);
	})
	logoMobile.addEventListener('click', handleToggle);
	toggle.addEventListener('click', handleToggle);
	window.addEventListener('resize', handleResize);
	document.addEventListener('keydown', handleKeyDown);
};

export { initNavigation };
